/*!
 * Inview
 * use : in-view.min.js
 */

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".l-banner,.l-section,.l-section>*>*,.l-detail-list>*,.l-point-list>*,.l-button-inner").forEach((element) => {
    element.classList.add("inview");
  });
  inView(".inview").on("enter", function (el) {
    el.classList.add("is-inview");
  });
});
